import { render, staticRenderFns } from "./BudgetForm.vue?vue&type=template&id=5165f4fe&scoped=true"
import script from "./BudgetForm.vue?vue&type=script&lang=js"
export * from "./BudgetForm.vue?vue&type=script&lang=js"
import style0 from "./BudgetForm.vue?vue&type=style&index=0&id=5165f4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5165f4fe",
  null
  
)

export default component.exports